<template>
  <div class="d-flex align-items-center mt-4">
    <div class="label">{{ $t('bill.group') }}:</div>
    <div class="show-item d-flex" v-for="(item, index) in canShowGroups" :key="index">
      <div class="prevs-add">
        <icon v-if="canShowGroups.length < max" class="insert-prevs" type="insert" @click="addGroup(index)" />
      </div>
      <div class="value-container">
        <a-popover trigger="click">
          <template slot="content">
            <a-form :form="form" hideRequiredMark>
              <!-- 聚合1 -->
              <a-form-item class="mb-0">
                <span class="label-w">{{$t('bill.group')}}:</span>
                <a-select v-model="item.group" style="width:150px" @change="(val) => groupChange(val, index)">
                  <a-select-option v-for="item in groupOpts" :key="item.key" :disabled="getDisabled(item, index)">{{item.value}}</a-select-option>
                </a-select>
              </a-form-item>
              <!-- 标签1 -->
              <a-form-item v-if="item.group === 'tag'" class="mb-0">
                <span class="label-w">{{$t('bill.key')}}</span>
                <a-select
                  style="width:150px"
                  v-model="item.tag"
                  :loading="tagLoading"
                  show-search
                  :dropdownMatchSelectWidth="false"
                  dropdownClassName="dropdown-item-word-wrap"
                  @change="(val) => handleTagGroupChange(val, 'tag', index)">
                  <a-select-option v-for="item in tagOpts" :key="item.key" :disabled="getTagDisabled(item, index, 'tag')">{{item.value}}</a-select-option>
                </a-select>
              </a-form-item>
              <!-- 业务标签1 -->
              <a-form-item v-if="item.group === 'instance_tag'" class="mb-0">
                <span class="label-w">{{$t('bill.key')}}</span>
                <a-select
                  style="width:150px"
                  v-model="item.instance_tag"
                  :loading="instanceTagLoading"
                  show-search
                  :dropdownMatchSelectWidth="false"
                  dropdownClassName="dropdown-item-word-wrap"
                  @change="(val) => handleTagGroupChange(val, 'instance_tag', 'index')">
                  <a-select-option v-for="item in instanceTagOpts" :key="item.key" :disabled="getTagDisabled(item, index, 'instance_tag')">{{item.value}}</a-select-option>
                </a-select>
              </a-form-item>
              <!-- 项目标签1 -->
              <a-form-item v-if="item.group === 'project_tag'" class="mb-0">
                <span class="label-w">{{$t('bill.key')}}</span>
                <a-select
                  style="width:150px"
                  v-model="item.project_tag"
                  :loading="projectTagLoading"
                  show-search
                  :dropdownMatchSelectWidth="false"
                  dropdownClassName="dropdown-item-word-wrap"
                  @change="(val) => handleTagGroupChange(val, 'project_tag', 'index')">
                  <a-select-option v-for="item in projectTagOpts" :key="item.key" :disabled="getTagDisabled(item, index, 'project_tag')">{{item.value}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </template>
          <div class="show-item-value">{{ getShowLabel(index) }}</div>
        </a-popover>
        <icon v-if="canShowGroups.length > 1" type="cancel" class="item-cancel" @click="removeGroup(index)" />
      </div>
    </div>
    <a-button v-if="canShowGroups.length < max" class="ml-3" shape="circle" icon="plus" size="small" @click="() => addGroup(this.formData.groups.length)" />
    <div class="ml-3" v-if="formData.groups.some(item => ['tag', 'project_tag', 'instance_tag'].includes(item.group))">
      {{formData.tag_val_split ? $t('bill.split_chart') : ''}}
      <a-button type="link" @click="showSplitConfig" style="padding: 0">{{splitMessage}}</a-button>
      <a-button v-if="formData.tag_val_split" type="link" @click="splitChange('')">{{$t('common.cancel')}}</a-button>
    </div>
  </div>
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import { mixSortFunc } from '@/utils/utils'
import { ANALYSIS_GROUP_RATE_LIST, ANALYSIS_SPLITS_MAP } from '@Bill/constants'

export default {
  name: 'AnalysisesGroup',
  mixins: [WindowsMixin],
  props: {
    formData: Object,
  },
  data () {
    return {
      form: this.$form.createForm(this),
      group: [],
      tagLoading: false,
      instanceTagLoading: true,
      projectTagLoading: true,
      tagOpts: [],
      instanceTagOpts: [],
      projectTagOpts: [],
    }
  },
  computed: {
    max () {
      return this.formData.show_bill_type === 'show_bill_usage' ? 1 : 5
    },
    canShowGroups () {
      return this.formData.groups.filter(item => item.group !== 'aggregate_usage_unit')
    },
    groupOpts () {
      const targets = ANALYSIS_GROUP_RATE_LIST.filter(item => {
        if (this.$store.getters.isProjectMode) {
          return item.key !== 'domain'
        }
        const fieldMap = {
          cloudprovider_name: 'cloudprovider',
          owner_name: 'owner',
          linked_name: 'linked',
        }
        const field = fieldMap[item.key] || item.key
        if (!this.$isScopedPolicyMenuHidden(`fee_hidden_items.${field}`)) {
          return item
        }
      })
      const rets = targets.map(item => {
        if (item.t) {
          item.value = this.$t(item.t)
        }
        return item
      })
      return rets
    },
    splitMessage () {
      return this.formData.tag_val_split ? ANALYSIS_SPLITS_MAP[this.formData.tag_val_split].label : this.$t('bill.split')
    },
    tagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date = '', end_date = '' } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
      }
    },
    instanceTagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date, end_date } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
      }
    },
    projectTagParams () {
      const {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
      } = this.formData
      const { start_date = '', end_date = '' } = this.formData.date
      const startDate = this.$moment(start_date.substr(0, start_date.length - 2)).format('YYYYMMDD')
      const endDate = this.$moment(end_date.substr(0, end_date.length - 2)).format('YYYYMMDD')
      return {
        platform_brand,
        account_id,
        cloudprovider_id,
        region_ext_id,
        charge_type,
        start_day: startDate,
        end_day: endDate,
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
      }
    },
  },
  methods: {
    getShowLabel (index) {
      const { group } = this.formData.groups[index]
      const target = this.groupOpts.filter(item => item.key === group)
      if (target.length) {
        if (['tag', 'project_tag', 'instance_tag'].includes(group)) {
          return `${target[0].value} - ${this.$t('bill.key')}${this.getTagKey(this.formData.groups[index][group] || '-')}`
        }
        return target[0].value
      }
      return ''
    },
    addGroup (index) {
      const value = this.formData.groups
      value.splice(index, 0, { group: undefined, tag: undefined, project_tag: undefined, instance_tag: undefined })
    },
    groupChange (val, index) {
      this.$set(this.formData.groups[index], 'group', val)
      if (val === 'tag') {
        this.fetchTags([index])
      }
      if (val === 'project_tag') {
        this.fetchProjectTags([index])
      }
      if (val === 'instance_tag') {
        this.fetchInstanceTags([index])
      }
    },
    getTagKey (key) {
      const ret = key.replace('user:', '')
      return ret
    },
    getDisabled (item, index) {
      return this.formData.groups.some((group, idx) => {
        return !['tag', 'instance_tag', 'project_tag'].includes(group.group) && index !== idx && item.key === group.group
      })
    },
    getTagDisabled (item, index, type) {
      return this.formData.groups.some((group, idx) => {
        return idx !== index && type === group.group && group[type] === item.key
      })
    },
    async fetchTags (indexs) {
      this.tagLoading = true
      try {
        if (!this.tagOpts.length) {
          const result = await new this.$Manager('res_tag_details', 'v1').list({
            params: {
              ...this.tagParams,
              key_prefix: ['user:', 'ext:'],
              scope: this.$store.getters.scope,
              key_only: true,
            },
          })
          const { data: tagsList = [] } = result.data
          const tagKeys = Array.from(new Set(tagsList.map(item => {
            return item.key
          })))
          const tagOpts = tagKeys.map(item => {
            return {
              key: item,
              value: this.getTagKey(item),
            }
          })
          tagOpts.sort((a, b) => a.value.localeCompare(b.value))
          this.tagOpts = tagOpts
        }
        indexs.forEach(idx => {
          const opts = this.tagOpts.filter(item => {
            return !this.formData.groups.some(i => i.group === 'tag' && i.tag === item.key)
          })
          if (this.formData.groups[idx].group === 'tag') {
            this.formData.groups[idx].tag = opts.length ? opts[0].key : undefined
          }
        })
        this.tagLoading = false
      } catch (err) {
        this.tagLoading = false
        throw err
      }
    },
    async fetchInstanceTags (indexs) {
      this.instanceTagLoading = true
      try {
        if (!this.instanceTagOpts.length) {
          const result = await new this.$Manager('instance_tag_details', 'v1').list({
            params: {
              ...this.instanceTagParams,
              // key_prefix: ['user:', 'ext:'],
              scope: this.$store.getters.scope,
              key_only: true,
            },
          })
          const { data: tagsList = [] } = result.data
          const tagKeys = Array.from(new Set(tagsList.map(item => {
            return item.key
          })))
          const instanceTagOpts = tagKeys.map(item => {
            return {
              key: item,
              value: this.getTagKey(item),
            }
          })
          instanceTagOpts.sort((a, b) => mixSortFunc((a.value || '').toLowerCase(), (b.value || '').toLowerCase()))
          this.instanceTagOpts = instanceTagOpts
        }
        indexs.forEach(idx => {
          const opts = this.instanceTagOpts.filter(item => {
            return !this.formData.groups.some(i => i.group === 'instance_tag' && i.instance_tag === item.key)
          })
          if (this.formData.groups[idx].group === 'instance_tag') {
            this.formData.groups[idx].instance_tag = opts.length ? opts[0].key : undefined
          }
        })
        this.instanceTagLoading = false
      } catch (err) {
        this.instanceTagLoading = false
      }
    },
    async fetchProjectTags (indexs) {
      this.projectTagLoading = true
      try {
        if (!this.projectTagOpts.length) {
          const result = await new this.$Manager('project_tag_details', 'v1').list({
            params: {
              ...this.projectTagParams,
              // key_prefix: ['user:', 'ext:'],
              scope: this.$store.getters.scope,
              key_only: true,
            },
          })
          const { data: tagsList = [] } = result.data
          const tagKeys = Array.from(new Set(tagsList.map(item => {
            return item.key
          })))
          const projectTagOpts = tagKeys.map(item => {
            return {
              key: item,
              value: this.getTagKey(item),
            }
          })
          projectTagOpts.sort((a, b) => mixSortFunc((a.value || '').toLowerCase(), (b.value || '').toLowerCase()))
          this.projectTagOpts = projectTagOpts
        }
        indexs.forEach(idx => {
          const opts = this.projectTagOpts.filter(item => {
            return !this.formData.groups.some(i => i.group === 'project_tag' && i.project_tag === item.key)
          })
          if (this.formData.groups[idx].group === 'project_tag') {
            this.formData.groups[idx].project_tag = opts.length ? opts[0].key : undefined
          }
        })
        this.projectTagLoading = false
      } catch (err) {
        this.projectTagLoading = false
      }
    },
    handleTagGroupChange (val, type, index) {
      const groups = R.clone(this.formData.groups)
      groups[index][type] = val
      this.formData.groups = groups
    },
    removeGroup (index) {
      this.$set(this.formData, 'groups', this.formData.groups.filter((item, idx) => idx !== index))
    },
    showSplitConfig () {
      this.createDialog('BillAnalysisSetSplitDialog', {
        split: this.formData.tag_val_split,
        splitChange: this.splitChange,
      })
    },
    splitChange (split) {
      if (this.formData.tag_val_split !== split) {
        this.formData.tag_val_split = split
      }
    },
  },
}
</script>

<style lang="less" scoped>
.show-item {
  margin-left: 9px;
}
.value-container {
  border: solid 1px #d9d9d9;
  position: relative;
}
.show-item-value {
  padding: 0 15px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  min-width: 100px;
}
.prevs-add {
  position: relative;
  width: 9px;
  height: 30px;
  .insert-prevs {
    position: absolute;
    left: -9px;
    top: -10px;
    font-size: 18px;
    cursor: pointer;
    display: none;
    color: #d9d9d9;
    &:hover {
      color: var(--antd-wave-shadow-color);
    }
  }
}
.item-cancel {
  position: absolute;
  right: -9px;
  bottom: -9px;
  // opacity: 0.7;
  background: #fff;
  font-size: 18px;
  display: none;
  cursor: pointer;
  padding: 3px;
  border-radius: 50%;
  &:hover {
    color: var(--antd-wave-shadow-color);
  }
  color: #d9d9d9;
}
.show-item:hover {
  .insert-prevs {
    display: block;
  }
  .item-cancel {
    display: block;
  }
}
.label-w {
  display: inline-block;
  width: 50px;
}
</style>
